// extracted by mini-css-extract-plugin
export default {"seoFieldsWrapper":"SeoFields_seoFieldsWrapper__tKRSv","panelHeader":"SeoFields_panelHeader__X+i6J","formTextarea":"SeoFields_formTextarea__Hnuio"};